import request from '@/util/request'
import {
  JSON_CONFIG
} from '@/util/helper.js'

export function getPatientProfile (patientId) {
  return request({
    url: `/patient/${patientId}`,
    method: 'get',
    header: JSON_CONFIG
  })
}

export function updatePatientProfile (patientId, requestBody) {
  return request({
    url: `/patient/${patientId}`,
    method: 'post',
    header: JSON_CONFIG,
    data: requestBody
  })
}

export function getSurgeryRecord (patientId) {
  return request({
    url: `/patient/${patientId}/surgeryRecord`,
    method: 'get',
    header: JSON_CONFIG
  })
}

export function setSurgeryRecord (patientId, requestBody) {
  return request({
    url: `/patient/${patientId}/surgeryRecord`,
    method: 'post',
    header: JSON_CONFIG,
    data: requestBody
  })
}



// WEBPACK FOOTER //
// ./src/api/patient/profile.js